import Card, { Content } from 'xpi-black-ui/Common/Card';
import { SomaIcon } from '@soma/react';
import styled, { css } from 'styled-components';
import Badge from '../../Utils/Badge';
import OperationLogo from '../../Utils/OperationLogo';

// BLACK UI
export const BlackUICard = styled(Card)`
  height: 32rem;
  width: 19rem;

  @media only screen and (min-width: 1360px) {
    width: 20rem;
  }
`;

export const BlackUICardContent = styled(Content)`
  margin: 1rem 0;
`;

// SOMA UI
export const SomaUIArrowUpIcon = styled(SomaIcon).attrs(() => ({
  size: 'sm',
  icon: 'arrow-up',
  color: '#0A9E5A',
}))``;

export const SomaUIArrowDownIcon = styled(SomaIcon).attrs(() => ({
  size: 'sm',
  icon: 'arrow-down',
  color: '#CC3333',
}))``;

// CUSTOM UI
export const CustomOperationLogo = styled(OperationLogo)``;

export const CustomBadge = styled(Badge)`
  margin: 1rem 0;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .soma-badge {
    padding: 2px 6px;
    display: flex;
    align-items: center;
    font-size: 12px;
    margin-left: 11px;
    max-height: 20px;
    min-height: auto;
  }
`;

export const CustomTitle = styled.h2`
  color: white;
`;

export const CustomSubTitle = styled.h4`
  color: white;
`;

export const CustomCategoryTitle = styled.span`
  margin-bottom: 0.5rem;
  color: #B8B8B8;
`;

export const CustomCategorySubTitle = styled.span`
  font-size: 1rem;
  color: white;
`;

export const CustomObjectiveText = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  text-align: justify;
  overflow: hidden;
  font-size: 1rem;
  color: white;
`;

export const CustomCardHeader = styled.header`
  padding-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 1px solid #666666;
`;

export const CustomCardItem = styled.div`
  margin: 1rem 0;
  display: flex;

  ${({ isOperationInformation }) => !isOperationInformation && css`
    gap: 0 0.5rem;
  `}

  ${({ isOperationInformation }) => isOperationInformation && css`
    align-items: center;
  `}

  ${({ isUnitaryValue }) => isUnitaryValue && css`
    justify-content: space-between;
  `}

  ${({ isPercentageValue }) => isPercentageValue && css`
    justify-content: flex-start;
  `}

  ${({ isDateValue, isObjectiveValue }) => (isDateValue || isObjectiveValue) && css`
    flex-direction: column;
    justify-content: flex-start;
  `}
`;

export const CustomContainer = styled.div`
  display: flex;
  margin: ${({ margin }) => margin || '0 1.5rem 0 0'};
  flex-direction: ${({ flexDirection }) => flexDirection || 'column'};
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};
`;
